import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    box: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1,
      padding: 2,
      borderRadius: 2,
      background: colors.black_1,
      textTransform: 'none',
    },
    icon: {
      borderRadius: '50%',
      padding: 2,
      background: colors.white_1,
      border: '1px solid ' + colors.white,

      '& svg': {
        color: colors.white,
        width: 32,
        height: 32,
        display: 'block',
      },
    },
    title: {
      textTransform: 'capitalize',
      color: colors.white,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.5,
    },
  };
};
